<div class="row">
  <button class="btnBack" (click)="backBtn()" type="button">
    <span class="back-arrow">←</span>
    <span class="back-text">Back</span>
  </button>
  <!-- <a [routerLink]="['/member-dashboard']" class="memDash" [queryParams]="{ memberId:memberId}" style="margin-left: 80%;">
   Member Dashboard</a> -->
</div>

<div class="row mt-5">
  <div class="col-md-12 col-lg-6">
    <div class="title">{{memberName}}</div>
  </div>
</div>
<div class="row mt-3" *ngIf="isSubMenu == 6">
  <div class="col-md-12 goal-info-bar">
    <span class="goal-info-item">{{goalSummary.plan}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">Age:</span>&nbsp;<span class="goal-info-item">{{goalSummary.age}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">Gender:</span>&nbsp;<span class="goal-info-item">{{goalSummary.gender}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">DOB:</span>&nbsp;<span class="goal-info-item">{{goalSummary.dob}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">Height:</span>&nbsp;<span class="goal-info-item">{{goalSummary.height}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">Weight:</span>&nbsp;
    <span class="goal-info-item">
      {{goalSummary.weight}}
      <span *ngIf="goalSummary.weightTimestamp" class="goal-info-timestamp"> {{goalSummary.weightTimestamp}}</span>
    </span> &nbsp; | &nbsp;
    <span class="goal-info-label">Level of Care:</span>&nbsp;<span class="goal-info-item">{{goalSummary.levelOfCare}}</span> &nbsp; | &nbsp;
    <span class="goal-info-label">BMI:</span>&nbsp;
    <span class="goal-info-item">
      {{goalSummary.bmi}}
      <span *ngIf="goalSummary.bmiTimestamp" class="goal-info-timestamp"> {{goalSummary.bmiTimestamp}}</span>
    </span> &nbsp; | &nbsp;
    <span class="goal-info-label">Last HbA1c:</span>&nbsp;<span class="goal-info-item">{{goalSummary.lastHbA1c}}</span>
  </div>
</div>
<div id="content-page" class="content-page">

  <div class="container-fluid">

    <div class="row">
      <div class="col-md-12 ">
        <mat-list role="list" style="display: flex;">
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Dairy'}" (click)="selectedTab(1,1,'Dairy')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Dairy'}">Member Dairy</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Ques'}" (click)="selectedTab(2,1,'Ques')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Ques'}">Questionnaire </div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Lab'}" (click)="selectedTab(3,12,'Lab')">
              <!--<div class="tab" [ngClass]="{'activeTab': mainTab === 'Lab'}">-->
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Lab'}">Lab Work </div>
            </div>
          </mat-list-item>
            <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Med'}" (click)="selectedTab(11,11,'Med')" >
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Med'}">Medications </div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Meet'}" (click)="selectedTab(4,4,'Meet')">
              <!--<div class="tab" [ngClass]="{'activeTab': mainTab === 'Meet'}" >-->
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Meet'}">Meeting </div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'HealthTool'}" (click)="selectedTab(7,0,'HealthTool')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'HealthTool'}">Health Tool</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Monitor'}" (click)="selectedTab(5,6,'Monitor')">

              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Monitor'}">Monitoring </div>
            </div>
          </mat-list-item>
                    <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Goals'}" (click)="selectedTab(6,0,'Goals')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Goals'}">Goals</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Habits'}" (click)="selectedTab(8,16,'Habits')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Habits'}">Habits</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab" [ngClass]="{'activeTab': mainTab === 'Wishes'}" (click)="selectedTab(9,0,'Wishes')">
              <div class="tabContent" [ngClass]="{'activeTabContent': mainTab === 'Wishes'}">Wishes</div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>

    </div>


    <div class="row mt-4" *ngIf="isSubMenu == 2">
      <div class="col-md-12 ">
      </div>

    </div>


    <div class="row mt-4" *ngIf="isSubMenu == 5">
      <div class="col-md-12 ">
        <mat-list role="list" style="display: inline-flex;">
          <!-- <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'activitygraph'}" (click)="subSelectedTab(6,'activitygraph')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'activitygraph'}">Activity Graph </div>
            </div>
          </mat-list-item> -->
          <!-- <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'sleepgraph'}" (click)="subSelectedTab(8,'sleepgraph')">

              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'sleepgraph'}">Sleep graph </div>
            </div>
          </mat-list-item> -->
          <!-- <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Food'}" (click)="subSelectedTab(7,'Food')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Food'}">Food Logging </div>
            </div>
          </mat-list-item> -->

          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Dashboard'}" (click)="navigateToMemberDashboard()">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Dashboard'}">Member Dashboard</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Meal'}" (click)="subSelectedTab(9,'Meal')">

              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Meal'}">Meal Plan History</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Note'}" (click)="subSelectedTab(10,'Note')">
              <!--<div class="tab1" [ngClass]="{'activeTab1': subTab === 'Note'}">-->
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Note'}">Progress Notes </div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'Meeting'}" (click)="subSelectedTab(15,'Meeting')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'Meeting'}">Meeting Notes </div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'LogHbA1c'}" (click)="subSelectedTab(17,'LogHbA1c')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'LogHbA1c'}">Log HbA1c</div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>

    </div>

    <div class="row mt-4" *ngIf="isSubMenu == 3">
      <div class="col-md-12 ">
        <mat-list role="list" style="display: inline-flex;">
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'bloodreport'}" (click)="subSelectedTab(12,'bloodreport')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'bloodreport'}">Blood Report Analyses History</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'biweeklyreport'}" (click)="subSelectedTab(14,'biweeklyreport')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'biweeklyreport'}">Biweekly Report History</div>
            </div>
          </mat-list-item>
          <mat-list-item role="listitem">
            <div class="tab1" [ngClass]="{'activeTab1': subTab === 'labreports'}" (click)="subSelectedTab(13,'labreports')">
              <div class="tabContent1" [ngClass]="{'activeTabContent1': subTab === 'labreports'}">Lab Reports</div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </div>

    <div class="row mt-5" *ngIf="isMemberDairy">
      <div class="col-md-12 col-lg-6">
        <div class="iq-card iq-card-block iq-card-stretch iq-card-height">
          <div class="iq-card-body">
            <div class="title">Member Information</div>

          </div>


        </div>
      </div>

    </div>

    <div class="row mt-4" style="display: flex;" *ngIf="isMemberDairy">
      <div class="col-md-12" style="display: flex;">
        <app-member-detail-form></app-member-detail-form>
      </div>
    </div>

    <div class="row mt-4" *ngIf="subMenu== 1 && !isMemberDairy">
      <div class="col-md-12">
        <app-personality></app-personality>
      </div>
    </div>
    <div class="row mt-4" *ngIf="isSubMenu == 6">
      <div class="col-md-12">
        <app-goal [memberId]="memberId"></app-goal>
      </div>
    </div>
    <div class="col-md-12 mt-4" *ngIf="subMenu ==2">
      <!-- <app-life-style></app-life-style> -->
      <app-dietary-details></app-dietary-details>
    </div>

    <div class="" *ngIf="subMenu == 3">
      <!-- <app-health></app-health> -->
      <app-dietary-preference></app-dietary-preference>
    </div>

    <div class="col-md-12" *ngIf="subMenu == 4">
      <!-- <app-dietary></app-dietary> -->
      <app-lifestyle-condition></app-lifestyle-condition>
    </div>

    <div class="row mt-4" *ngIf="subMenu == 5">
      <app-fitness></app-fitness>
    </div>
    <!-- <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 6">
      <activity-graph-graph></activity-graph-graph>
    </div> -->
    <!-- <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 7">
      <app-all-food-logs></app-all-food-logs>
    </div> -->
    <!-- <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 8">
      <app-sleep-graph></app-sleep-graph>
    </div> -->
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 9">
      <app-mealplan-history></app-mealplan-history>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 10">
      <app-progress-notes></app-progress-notes>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 15">
      <app-meeting-notes></app-meeting-notes>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 17">
      <app-log-hba1c></app-log-hba1c>
    </div>
     <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 11">
      <app-member-medication></app-member-medication>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 12">
      <app-blood-report-analyses></app-blood-report-analyses>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 14">
      <app-biweekly-report-history></app-biweekly-report-history>
    </div>
    <div class="col-md-12 mt-4" style="width:100%" *ngIf="subMenu == 13">
      <app-dietary-preference></app-dietary-preference>
    </div>
    
    <!-- Health Tools Tab Content -->
    <div class="row mt-4" *ngIf="isSubMenu == 7 && memberName">
      <div class="col-md-12">
        <app-md-health-tools [memberDetail]="memberDetail" [memberId]="memberId"></app-md-health-tools>
      </div>
    </div>

    <!-- Habits Tab Content -->
    <div class="row mt-4" *ngIf="isSubMenu == 8">
      <div class="col-md-12">
        <app-reminder [memberId]="memberId"></app-reminder>
      </div>
    </div>

    <!-- Wishes Tab Content -->
    <div class="row mt-4" *ngIf="isSubMenu == 9">
      <div class="col-md-12">
        <app-wishes [memberId]="memberId"></app-wishes>
      </div>
    </div>

  </div>
</div>
